import {
    dataInitialModal,
    dataSelectedTank,
    defaultParamsFilter,
    defaultFields
} from "./state";

/**
 * Mutación para restablecer los datos iniciales del filtro.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetDataFilter(state) {
    state.filter = defaultParamsFilter()
}

/**
 * Mutación manipular/alterar los datos del filtro.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setDataFilter(state, nextState) {
    state.filter = nextState
}

/**
 * Mutación manipular/alterar los datos del Modal.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setModal(state, nextState) {
    state.modal = nextState
}

/**
 * Mutación restablecer el estado inicial del Modal.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetModal(state) {
    state.modal = dataInitialModal()
}

/**
 * Mutación manipular/alterar el estado de si los datos de la tabla están cargando o no.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setLoadingDataTable(state, nextState) {
    state.loadingDataTable = nextState
}

/**
 * Mutación restablecer el estado inicial del tanque seleccionado.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function resetSelectedTank(state) {
    state.selectedTank = dataSelectedTank()
}

/**
 * Mutación manipular/alterar el estado del tanque seleccionado.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setSelectedTank(state, nextState) {
    state.selectedTank = nextState
}

/**
 * Mutación manipular/alterar la información de la tabla de tanques.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setTableConfig(state, nextState) {
    state.tableConfig = { 
        ...state.tableConfig,
        items: nextState.items,
        data: nextState.data
    }
}

/**
 * Mutación manipular/alterar la información de la cabecera de la tabla.
 *
 * @param {*} state
 * @author Fernando Claros
 */
export function setDefaultFieldsTableConfig(state) {
    state.tableConfig = { 
        ...state.tableConfig,
        fields: defaultFields(),
    }
}

/**
 * Mutación manipular/alterar el estado del filtro ítems por pagina.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setPerPagePagination(state, nextState) {
    state.filter = { ...state.filter, per_page: nextState }
}

/**
 * Mutación manipular/alterar el estado del filtro página de la paginación.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setPagePagination(state, nextState) {
    state.filter = { ...state.filter, page: nextState }
}

/**
 * Mutación manipular/alterar el estado de las unidades de medida.
 *
 * @param {*} state
 * @param {*} nextState
 * @author Fernando Claros
 */
export function setUnitOfMeasures(state, nextState) {
    state.unitOfMeasures = nextState
}